import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { InputBox } from "../../components/CustomWidgets/InputBox";
import "react-phone-number-input/style.css";
// import SelectBox from "../CustomWidgets/SelectBox";
import { Button, Input, Table, Modal } from "antd";
import "../../styles.css";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { UpdateRetailerDetails } from "../../API  Functions/ProfileFunctions";
import LoadingSpinner from "../Loading";
import { checkPermission } from "../../Utils/permissionHelper";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import { toast } from "react-toastify";
import { Trash2 } from "lucide-react"; // delete icon
import UpdatedProfile from "../../modals/UpdatedProfile";
import * as Yup from "yup";
import  SelectBox, { MultiSelectBox } from "../CustomWidgets/SelectBox";

import { Select } from "antd";
const { Option } = Select;

const SerialNumberCell = ({ record, serialList, setSerialList }) => {
  const { t } = useTranslation();

  const [localValue, setLocalValue] = React.useState(record.serial_number);

  useEffect(() => {
    setLocalValue(record.serial_number);
  }, [record.serial_number]);

  const handleBlur = () => {
    const trimmed = localValue.trim();
    if (!trimmed) return;

    // const duplicate = serialList.some(
    //   (s) =>
    //     s.serial_number === trimmed && s.serial_number !== record.serial_number
    // );

    // if (duplicate) {
    //   toast.error(t("Duplicate serial number not allowed"));
    //   setLocalValue(record.serial_number);
    //   return;
    // }

    // ✅ Only update global list if changed
    if (trimmed !== record.serial_number) {
      setSerialList((prev) =>
        prev.map((s) =>
          s.id === record.id ? { ...s, serial_number: trimmed } : s
        )
      );
    }
  };

  return (
    <Input
      value={localValue}
      onChange={(e) =>
        setLocalValue(e.target.value.replace(/[^a-zA-Z0-9]/g, ""))
      }
      onBlur={handleBlur}
      className="w-[200px] h-[40px]"
      maxLength={20}
    />
  );
};

const ETASetup = ({
  payload,
  onDataSubmit,
  profiledetail,
  data,
  fetchdetails,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showUpdatedProfile, setShowUpdatedProfile] = useState(false);
  const [restricted, setrestricted] = useState(true);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [serialNumber, setSerialNumber] = useState("");
  const [serialList, setSerialList] = useState([]);
  const [initialSerialList, setInitialSerialList] = useState([]);
  const [confirmVisible, setConfirmVisible] = useState(false);

  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const isGinne = useSelector((state) => state?.geneLoginReducer?.isGinneLogin);

  const [initialState, setInitialState] = useState({});
  const [isChanged, setIsChanged] = useState(false);

  const [deletedSerials, setDeletedSerials] = useState([]);

const validationSchema = Yup.object().shape({
  tax_card_number: Yup.string()
    .required(t("Tax ID is required"))
    .matches(/^\d{9}$/, t("Tax ID must be exactly 9 digits")),

  tax_activity_code: Yup.string()
    .required(t("Tax Activity Code is required"))
    .matches(/^\d{4}$/, t("Tax Activity Code must be exactly 4 digits")),

  // ✅ New validations
  // device_serial_number: Yup.string()
  //   .required(t("Device serial number is required")),

  governate: Yup.string()
    .required(t("Governate is required")),

  building_number: Yup.string()
    .required(t("Building number is required")),

  buyer_type: Yup.string()
    .required(t("Buyer type is required"))
    .oneOf(["B", "P", "F"], t("Buyer type must be B, P, or F")),

  // buyer_id: Yup.string().when("buyer_type", {
  //   is: (val) => val !== "F",   // if NOT "F"
  //   then: (schema) => schema.required(t("Buyer ID is required")),
  //   otherwise: (schema) => schema.notRequired(),
  // }),
});


  useEffect(() => {
    getStoreusers();
  }, []);

  const getStoreusers = () => {
    setLoading(true);
    getStoreUsers(user_id)
      .then((res) => {
        if (res?.result[0]?.status_code === 200) {
          const users = res.result[0]?.response?.filter(user => user.active === true && user.user_type == "online_pos");
          if (users) setUsers(users);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (data) {
      const addr = data.retailer_details?.shop_address;
      const fullAddress = addr
        ? `${addr.street || ""}, ${addr.street2 || ""}, ${addr.city || ""}, ${
            addr.state || ""
          }, ${addr.country || ""}, ${addr.zip || ""}`
        : "";

      formik.setValues({
        business_name: data.retailer_details.company_name || "",
        business_name_ar: data.retailer_details.company_name_ar || "",
        business_address: fullAddress,
        tax_card_number: data.retailer_details.tax_card_number || "",
        tax_activity_code: data.retailer_details.tax_activity_code || "",
        syndicate_license: data.retailer_details.syndicate_license || "",
        // device_serial_number: data.retailer_details.device_serial_number || "",
        governate: data.retailer_details.governate || "",
        building_number: data.retailer_details.building_number || "",
        floor: data.retailer_details.floor || "",
        room: data.retailer_details.room || "",
        landmark: data.retailer_details.landmark || "",
        additional_information:
          data.retailer_details.additional_information || "",
        buyer_type: data.retailer_details.buyer_type || "",
        // buyer_id: data.retailer_details.buyer_id || "",

        user_id: payload.user_id,
        store_id: payload.store_id,
      });

      if (
        data.retailer_details.serial_number &&
        Array.isArray(data.retailer_details.serial_number)
      ) {
        const formatted = data.retailer_details.serial_number.map((item) => ({
  id: item.id,
  serial_number: item.serial,

  // 🔥 IMPORTANT FIX — extract array of user IDs
  user_id: Array.isArray(item.user_list)
    ? item.user_list.map(u => u.user_id)
    : [],

  is_delete: false,
}));
        setSerialList(formatted);
setInitialSerialList(formatted);
        setInitialState({
          tax_card_number: data.retailer_details.tax_card_number || "",
          tax_activity_code: data.retailer_details.tax_activity_code || "",
          syndicate_license: data.retailer_details.syndicate_license || "",
          // device_serial_number:
          //   data.retailer_details.device_serial_number || "",
          governate: data.retailer_details.governate || "",
          building_number: data.retailer_details.building_number || "",
          floor: data.retailer_details.floor || "",
          room: data.retailer_details.room || "",
          landmark: data.retailer_details.landmark || "",
          additional_information:
            data.retailer_details.additional_information || "",
          buyer_type: data.retailer_details.buyer_type || "",
          // buyer_id: data.retailer_details.buyer_id || "",
          serialList: formatted,
        });
      }
    }
  }, [data]);

  const getRemovedUsers = (serialId, currentUserIds = []) => {
  const initialSerial = initialState?.serialList?.find(
    s => s.id === serialId
  );

  if (!initialSerial || !Array.isArray(initialSerial.user_id)) return [];

  // Users that existed before but are NOT in current list anymore
  return initialSerial.user_id.filter(
    oldId => !currentUserIds.includes(oldId)
  );
};


  const formik = useFormik({
    initialValues: {
      business_name: "",
      business_name_ar: "",
      business_address: "",
      tax_card_number: "",
      tax_activity_code: "",
      syndicate_license: "",
      // device_serial_number: "",
      governate: "",
      building_number: "",
      floor: "",
      room: "",
      landmark: "",
      additional_information: "",
      buyer_type: "",
      // buyer_id: "",
      user_id: payload.user_id,
      store_id: payload.store_id,
    },
    validationSchema,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values) => {
      if (!checkPermission("/settings/profile", isGinne)) return;

      setLoading(true);
      try {
        // ✅ Convert to required structure
        const serialArray = [
  ...serialList.map((s) => {
    const currentUsers = Array.isArray(s.user_id) ? s.user_id : [];

    return {
      id: s.id,
      serial: s.serial_number,
      user_ids: currentUsers,

      // 🔥 IMPORTANT PART — find removed users
      remove_user_ids: getRemovedUsers(s.id, currentUsers),

      is_delete: false,
    };
  }),

  ...deletedSerials.map((s) => ({
    id: s.id,
    serial: s.serial_number,
    user_ids: Array.isArray(s.user_id) ? s.user_id : [],
    remove_user_ids: Array.isArray(s.user_id) ? s.user_id : [], // all users removed if deleted
    is_delete: true,
  })),
];

const duplicateSerial = serialArray
  .map(s => s.serial)
  .find((serial, index, arr) => arr.indexOf(serial) !== index);

if (duplicateSerial) {
  toast.error(t("Duplicate serial numbers are not allowed"));
  return;
}

if(serialArray?.length < 1){
  toast.error(t('Add atleast one serial number'))
  return
}
// Check if any serial has ZERO users
const hasSerialWithoutUser = serialArray.some(
  (s) => !s.user_ids || s.user_ids.length === 0
);

if (hasSerialWithoutUser) {
  toast.error(t("Add at least one user to every serial number"));
  return;
}


        const apipayload = {
          user_id,
          // shop_name: values.business_name,
          // shop_name_ar: values.business_name_ar,
          // business_address: values.business_address,
          tax_card_number: values.tax_card_number,
          tax_activity_code: values.tax_activity_code,
          syndicate_license: values.syndicate_license,
          // device_serial_number: values.device_serial_number,
          governate: values.governate,
          building_number: values.building_number,
          floor: values.floor,
          room: values.room,
          landmark: values.landmark,
          additional_information: values.additional_information,
          buyer_type: values.buyer_type,
          // buyer_id: values.buyer_id,
          serial_number: serialArray,
        };

        const response = await UpdateRetailerDetails(apipayload);

        if (response?.status === "Update Successfully") {
          setShowUpdatedProfile(true);
          onDataSubmit();
          setrestricted(true);

          setInitialState({
            tax_card_number: values.tax_card_number,
            tax_activity_code: values.tax_activity_code,
            syndicate_license: values.syndicate_license,
            // device_serial_number: values.device_serial_number,
            governate: values.governate,
            building_number: values.building_number,
            floor: values.floor,
            room: values.room,
            landmark: values.landmark,
            additional_information: values.additional_information,
            buyer_type: values.buyer_type,
            // buyer_id: values.buyer_id,
            serialList: serialList,
          });
          setIsChanged(false);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    },
  });

  const checkIfChanged = (newSerialList, newValues) => {
    const initial = initialState;

    if (!initial || !initial.serialList) return true; // if initial not ready yet

    // Check if tax or activity changed
    if (
      initial.tax_card_number !== newValues.tax_card_number ||
      initial.tax_activity_code !== newValues.tax_activity_code
    ) {
      return true;
    }

    // Compare serial count
    if (initial.serialList.length !== newSerialList.length) return true;

    // Compare each serial number + assigned user
    const changed = newSerialList.some((s, i) => {
      const init = initial.serialList[i];
      return (
        s.serial_number !== init.serial_number ||
        (s.user_id || null) !== (init.user_id || null)
      );
    });

    return changed;
  };

  useEffect(() => {
    const changed = checkIfChanged(serialList, formik.values);
    setIsChanged(changed);
  }, [
    serialList,
    formik.values.tax_card_number,
    formik.values.tax_activity_code,
    formik.values.syndicate_license,
    // formik.values.device_serial_number,
    formik.values.governate,
    formik.values.building_number,
    formik.values.floor,
    formik.values.room,
    formik.values.landmark,
    formik.values.additional_information,
    formik.values.buyer_type,
    // formik.values.buyer_id,
  ]);

  const handleAddSerial = () => {
    if (!serialNumber.trim()) return;

    if (serialList.some((s) => s.serial_number === serialNumber.trim())) {
      toast.error(t("Duplicate serial number not allowed"));
      return;
    }

    const newSerial = {
      id: null,
      tempId: Date.now() + Math.random(),
      serial_number: serialNumber.trim(),
      user_id: null,
    };

    setSerialList([...serialList, newSerial]);
    setSerialNumber("");
  };

  const handleDeleteSerial = (id) => {
    const item = serialList.find((s) => s.id === id);

    // If item exists and has a valid id, mark it deleted for API
    if (item && item.id !== null) {
      setDeletedSerials((prev) => [...prev, { ...item, is_delete: true }]);
    }

    // Remove from UI table
    setSerialList((prev) => prev.filter((s) => s.id !== id));
  };

  const handleUserAssign = (rowKey, userId) => {
    setSerialList((prev) =>
      prev.map((s) =>
        (s.id ?? s.tempId) === rowKey ? { ...s, user_id: userId } : s
      )
    );
  };
  console.log("serialList==>",serialList);
  

  const handleSerialEdit = (id, newSerial) => {
    if (!newSerial.trim()) return;

    const duplicate = serialList.some(
      (s) => s.serial_number === newSerial.trim() && s.id !== id
    );
    if (duplicate) {
      toast.error(t("Duplicate serial number not allowed"));
      return;
    }

    setSerialList((prev) =>
      prev.map((s) =>
        s.id === id ? { ...s, serial_number: newSerial.trim() } : s
      )
    );
  };
const getAssignedUserIdsExceptCurrent = (currentRowKey) => {
  return serialList
    .filter(s => (s.id ?? s.tempId) !== currentRowKey && Array.isArray(s.user_id))
    .flatMap(s => s.user_id);   // ✅ FLATTEN all selected users
};



  const columns = [
    {
      title: t("Serial Number"),
      dataIndex: "serial_number",
      key: "serial_number",
      render: (text, record) => (
        <SerialNumberCell
          record={record}
          serialList={serialList}
          setSerialList={setSerialList}
        />
      ),
    },
{
  title: t("Assign to User"),
  dataIndex: "user_id",
  key: "assign_user",
  render: (text, record) => {
    const rowKey = record.id ?? record.tempId;

    // 🔥 All users already selected in OTHER rows
    const blockedUsers = getAssignedUserIdsExceptCurrent(rowKey);

    // ✅ Filter them out from dropdown
    const filteredOptions = users
      ?.filter(u => !blockedUsers.includes(u.user_id))
      .map(item => ({
        value: item.user_id,
        label: item.name,
      }));

    return (
      <MultiSelectBox
        componentWidth={"flex flex-col w-full"}
        name="assigned_users"
        placeholder={t("Select Users")}
        options={filteredOptions}
        value={record.user_id || []}   // ✅ must be array
        onChange={(event) => {
          handleUserAssign(rowKey, event.target.value);
        }}
      />
    );
  },
},
,
,
    {
      title: t("Action"),
      key: "action",
      render: (_, record) => (
        <Trash2
          className="text-red-500 cursor-pointer hover:scale-110 transition-transform"
          onClick={() => handleDeleteSerial(record.id)}
          size={18}
        />
      ),
    },
  ];

  console.log("formik.errors===>", formik.errors);
  console.log("formik.touched===>", formik.touched);

  const EnableETA = async(value)=>{
    if((!data.retailer_details.tax_activity_code || data.retailer_details.tax_activity_code == '')){
      toast.error(t("Please add all the details to enable ETA."))
      return;
    }
    setLoading(true)
    
    try{
      let payload={
         user_id:user_id,
         is_eta_enabled: !data?.retailer_details?.is_eta_enabled
              }
      const response = await UpdateRetailerDetails(payload);
if (response?.status === "Update Successfully") {
         onDataSubmit();
        }else{
          toast.error(t(response?.status))
        }
    }catch (err){
console.log(err)
    }finally{

    setLoading(false)
    }

  }

  return (
    <>
      {loading && <LoadingSpinner />}

      {/* Note Section */}
      <div className="flex justify-between items-center mt-4">
        <div className="mx-8 text-gray-600 italic text-sm">
        {t(
          "Note: The information below must be exactly the same as what you submitted to the ETA during registration."
        )}
      </div>
     

      </div>
    

      <form
        onSubmit={(e) => {
          e.preventDefault();
          setConfirmVisible(true);

          // formik.submitForm().then(() => {
          //     if (Object.keys(formik.errors).length === 0) {
          //     }
          // });
        }}
      >
        <div className="font-normal text-[#5c5c5c] mx-8  mt-8">
             <div className=" flex gap-x-2 items-center">
<p className="text-sm font-medium">{t("Enable ETA")}</p>
        <label className="flex cursor-pointer select-none items-center me-7">
                            <div className="relative">
                                <input
                                    type="checkbox"
                                    checked={data?.retailer_details?.is_eta_enabled}
                                    onChange={EnableETA}
                                    className="sr-only"
                                />
                                <div
                                    className={`box block h-6 w-12 rounded-full ${data?.retailer_details?.is_eta_enabled ? 'bg-green-500' : 'bg-gray-500'
                                        }`}
                                ></div>
                                <div
                                    className={`absolute left-1 top-1 flex h-4 w-5 items-center justify-center rounded-full bg-white transition ${data?.retailer_details?.is_eta_enabled ? 'translate-x-full' : ''
                                        }`}
                                ></div>
                            </div>
                        </label>
      </div>
          <div className="grid grid-cols-2 gap-6 my-4">
            <InputBox
              name="business_name"
              label={t("Business Name")}
              backgroundColor={"#EBEBEB"}
              disabled
              value={formik.values.business_name}
              className="cursor-not-allowed"
            />
            <InputBox
              name="business_address"
              label={t("Business Address")}
              backgroundColor={"#EBEBEB"}
              disabled
              value={formik.values.business_address}
              className="cursor-not-allowed"
            />
          </div>

          <div className="grid grid-cols-2 gap-3 my-4">
            <InputBox
              name="tax_card_number"
              label={t("Tax ID / RIN / TRN")}
              placeholder={t("Enter 9 digits")}
              maxLength={9}
              value={formik.values.tax_card_number}
              onChange={(e) => {
                if (/^\d{0,9}$/.test(e.target.value)) {
                  formik.setFieldValue("tax_card_number", e.target.value);
                }
              }}
              error={
                formik.touched.tax_card_number && formik.errors.tax_card_number
              }
              touched={
                formik.touched.tax_card_number && formik.errors.tax_card_number
              }
            />

            <InputBox
              name="tax_activity_code"
              label={t("Tax Activity Code")}
              placeholder={t("Enter 4 digits")}
              isRequird
              maxLength={4}
              value={formik.values.tax_activity_code}
              onChange={(e) => {
                if (/^\d{0,4}$/.test(e.target.value)) {
                  formik.setFieldValue("tax_activity_code", e.target.value);
                }
              }}
              error={
                formik.touched.tax_activity_code &&
                formik.errors.tax_activity_code
              }
              touched={
                formik.touched.tax_activity_code &&
                formik.errors.tax_activity_code
              }
            />
          
          </div>
          <div className="grid grid-cols-2 gap-6 my-4">
           
            <InputBox
              name="syndicate_license"
              label={t("Syndicate License")}
              placeholder={t("Enter syndicate license")}
              // maxLength={4}
              value={formik.values.syndicate_license}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("syndicate_license", true)}
              error={formik.errors.syndicate_license}
              touched={formik.errors.syndicate_license}
            />
             <InputBox
              name="buyer_type"
              label={t("Buyer Type")}
              isRequird
              backgroundColor={"#EBEBEB"}
              placeholder={t("Enter buyer type")}
              // maxLength={4}
              disabled
              value={formik.values.buyer_type}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("buyer_type", true)}
              error={formik.errors.buyer_type}
              touched={formik.errors.buyer_type}
            />
            {/* <InputBox
              name="device_serial_number"
              isRequird
              label={t("Device Serial Number")}
              placeholder={t("Enter device serial number")}
              // maxLength={4}
              value={formik.values.device_serial_number}
              onChange={formik.handleChange}
              onBlur={() =>
                formik.setFieldTouched("device_serial_number", true)
              }
              error={formik.errors.device_serial_number}
              touched={formik.errors.device_serial_number}
            /> */}
          </div>
<h3 className="text-base font-semibold mt-4 mb-2">
      Address Details
    </h3>
          <div className="grid grid-cols-2 gap-6 mb-4">
            <InputBox
              name="governate"
              label={t("Governate")}
              isRequird
              placeholder={t("Enter governate")}
              // maxLength={4}
              value={formik.values.governate}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("governate", true)}
              error={formik.errors.governate}
              touched={formik.errors.governate}
            />
            <InputBox
              name="building_number"
              label={t("Building Number")}
              isRequird
              placeholder={t("Enter building number")}
              // maxLength={4}
              value={formik.values.building_number}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("building_number", true)}
              error={formik.errors.building_number}
              touched={formik.errors.building_number}
            />
            
          </div>

          <div className="grid grid-cols-3 gap-6 my-4">
            <InputBox
              name="room"
              label={t("Room")}
              placeholder={t("Enter room")}
              // maxLength={4}
              value={formik.values.room}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("room", true)}
              error={formik.errors.room}
              touched={formik.errors.room}
            />
            <InputBox
              name="floor"
              label={t("Floor")}
              placeholder={t("Enter floor")}
              // maxLength={4}
              value={formik.values.floor}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("floor", true)}
              error={formik.errors.floor}
              touched={formik.errors.floor}
            />
            <InputBox
              name="landmark"
              label={t("Landmark")}
              placeholder={t("Enter landmark")}
              // maxLength={4}
              value={formik.values.landmark}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("landmark", true)}
              error={formik.errors.landmark}
              touched={formik.errors.landmark}
            />
            {/* <InputBox
              name="additional_information"
              label={t("Additional Information")}
              placeholder={t("Enter additional information")}
              // maxLength={4}
              value={formik.values.additional_information}
              onChange={formik.handleChange}
              onBlur={() =>
                formik.setFieldTouched("additional_information", true)
              }
              error={formik.errors.additional_information}
              touched={formik.errors.additional_information}
            /> */}
          </div>

          {/* <div className="grid grid-cols-2 gap-6 my-4">
            <InputBox
              name="buyer_type"
              label={t("Buyer Type")}
              isRequird
              placeholder={t("Enter buyer type")}
              // maxLength={4}
              value={formik.values.buyer_type}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("buyer_type", true)}
              error={formik.errors.buyer_type}
              touched={formik.errors.buyer_type}
            />
            <InputBox
              name="buyer_id"
              label={t("Buyer Id")}
              isRequird={formik.values.buyer_type == 'B' ||formik.values.buyer_type == 'P' }
              placeholder={t("Enter buyer type")}
              // maxLength={4}
              value={formik.values.buyer_id}
              onChange={formik.handleChange}
              onBlur={() => formik.setFieldTouched("buyer_id", true)}
              error={formik.errors.buyer_id}
              touched={formik.errors.buyer_id}
            />
          </div> */}

          {/* Serial Number Section */}
          <div className="my-6">
            <label className="block text-sm mb-2">{t("Device Serial Number")}</label>
            <div className="flex gap-3">
              <Input
                placeholder="Enter Serial Number"
                value={serialNumber}
                onChange={(e) => {
                  const value = e.target.value;
                  // Allow only letters (A-Z, a-z) and numbers (0-9)
                  const filteredValue = value.replace(/[^a-zA-Z0-9]/g, "");
                  setSerialNumber(filteredValue);
                }}
                className="w-[300px] h-[40px]"
                maxLength={20}
              />
              <Button
                type="button"
                onClick={handleAddSerial}
                className="text-primaryBlue mt-1 font-semibold rounded-lg inline border border-primaryBlue"
              >
                {"Add"}
              </Button>
            </div>
          </div>

          <Table
            dataSource={serialList}
            columns={columns}
            rowKey={(record) => record.id ?? record.tempId}
            pagination={false}
            className="mt-4"
          />
        </div>

        <div className="flex gap-5 mx-11 mt-8 mb-10 ">
          <button
            type="submit"
            // disabled={!isChanged}
            className={`w-[180px] h-[45px] rounded-lg font-semibold bg-primaryBlue text-white
            
            `}
          >
            {t("Update & Save")}
          </button>
        </div>
      </form>

      {/* Confirmation Modal */}
      <Modal
        title={t("Confirm Update")}
        open={confirmVisible}
        onCancel={() => setConfirmVisible(false)}
        onOk={() => {
          setConfirmVisible(false);
          formik.handleSubmit();
        }}
        okText={t("Confirm")}
        cancelText={t("Cancel")}
        okButtonProps={{
          className:
            "bg-primaryBlue hover:bg-primaryBlue text-white border-none",
        }}
      >
        <p>{t("Please check all the details carefully before proceeding.")}</p>
      </Modal>

      {showUpdatedProfile && (
        <UpdatedProfile
          onClose={() => {
            setShowUpdatedProfile(false);
            fetchdetails();
          }}
          message={t("ETA Setup Details Updated")}
        />
      )}
    </>
  );
};

export default ETASetup;
